<template>

    <img class="rounded-t h-80 w-full object-cover" :src="currentAd?.path" alt="business-account-banner">

</template>

<script>
export default {
    name: 'BusinessAccountBanner',
    props: {
        content: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            adInterval: null,
            adImageIndex: 0,
            currentAd: {
                link: '/',
                link_type: 0,
                path: '/img/logo.webp'
            }
        }
    },
    methods: {
        changeImage() {
            this.adImageIndex = (this.adImageIndex + 1) % this.content.length;
            this.currentAd = this.content[this.adImageIndex];

        }
    },
    mounted() {
        this.currentAd = this.content[0]
        if (this.content.length > 1) {
            this.adInterval = setInterval(this.changeImage, 5000); // Change image every 30 seconds
        }
    },
    unmounted() {
        clearInterval(this.adInterval)

    }
}


</script>